/**
 * Formats a timestamp into 'DD-MM-YY hh:mmAM/PM' or 'MM-DD-YY hh:mmAM/PM' format based on the user's location.
 * @param {number} timestamp - The timestamp to format.
 * @returns {string} - The formatted date string.
 */
export function formatTimestamp(value) {
  const date = new Date(value * 1000); // Convert seconds to milliseconds
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = String(date.getFullYear()).slice(-2);
  const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

  // Check if the user is in the America time zone
  const isTZAmerica = Intl.DateTimeFormat()
    .resolvedOptions()
    .timeZone.includes('America');

  const timestamp = isTZAmerica
    ? `${month}-${day}-${year}` // MM-DD-YY format
    : `${day}-${month}-${year}`; // DD-MM-YY format

  return `${timestamp} ${hours}:${minutes}${ampm}`;
}
